import { createApi as e } from "../../../node_modules/@reduxjs/toolkit/dist/query/react/rtk-query-react.modern.js";
import { useSelector as t } from "../../../node_modules/react-redux/dist/react-redux.js";
import { CACHE_EXPIRATION_TIME_REFERENCE_BOOK as s } from "../constants.js";
const r = (r2, p) => {
  const n = e({ reducerPath: "appSettingsApi", baseQuery: p({ baseUrl: `${r2}/app-settings/bims-settings` }), keepUnusedDataFor: s, endpoints: (e2) => ({ getAppSettings: e2.query({ query: () => ({ url: "/" }) }) }) }), { useGetAppSettingsQuery: i } = n;
  return { appSettingsApi: n, useGetAppSettingsQuery: i, useAppSettings: () => t(n.endpoints.getAppSettings.select()).data };
};
export {
  r as initializeAppSettingsApi
};
//# sourceMappingURL=appSettingsApi.js.map
